import isEmpty from "ramda/src/isEmpty";
import React from "react";
import { useQuery } from "react-query";
import { useHistory } from "react-router";

import { QUERY_AUTH } from "../services/auth/queries";

const PrivateRoutes = ({ children }) => {
  const history = useHistory();
  const { data: user } = useQuery(QUERY_AUTH);
  const isAuthenticated = !isEmpty(user);

  if (!isAuthenticated) {
    history.push("/");

    return <div />;
  }

  return <>{children}</>;
};

export default PrivateRoutes;
